<template>
  <div class="chips-container">
    <div class="contactDetail-content">
      <v-text-field
        :placeholder="contentData.responses.namebox.text"
        v-model="nameInput"
        outlined
        flat
        block
        label="Name"
        class="input"
      ></v-text-field>
      <v-text-field
        :placeholder="contentData.responses.birthdaybox.text"
        v-model="birthdayInput"
        outlined
        flat
        block
        label="Geburtsdatum"
        class="input"
        :rules="rules.birthday"
      ></v-text-field>
      <v-text-field
        :placeholder="contentData.responses.addressbox.text"
        v-model="addressInput"
        outlined
        flat
        block
        label="Straße + Hausnummer"
        class="input"
      ></v-text-field>
      <v-row>
        <v-col>
          <v-text-field
            :placeholder="contentData.responses.plzbox.text"
            v-model="plzInput"
            outlined
            flat
            block
            label="PLZ"
            class="input"
            :rules="rules.plz"
          ></v-text-field>
        </v-col>
        <v-col>
          <v-text-field
            :placeholder="contentData.responses.citybox.text"
            v-model="cityInput"
            outlined
            flat
            block
            label="Ort"
            class="input"
          ></v-text-field>
        </v-col>
      </v-row>
    </div>
    <div class="btns-wrap">
      <v-btn :disabled="!userMayProceed()" depressed block class="primary-txt-btn __h68" @click="submitAnswer()">{{
        contentData.responses.submitbutton
      }}</v-btn>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      nameInput: "",
      birthdayInput: "",
      addressInput: "",
      plzInput: "",
      cityInput: "",
      contentData: {
        responses: {
          namebox: {
            text: "placeholder text",
          },
          birthdaybox: {
            text: "placeholder text",
          },
          addressbox: {
            text: "placeholder text",
          },
          plzbox: {
            text: "placeholder text",
          },
          citybox: {
            text: "placeholder text",
          },
          submitbutton: "submit",
        },
        birthdayValidationMessage: "",
      },
      rules: {
        birthday: [
          input => this.isValidBirthday(input) || "Bitte geben Sie ein gültiges Geburtsdatum ein (Format: TT.MM.JJJJ)"
        ],
        plz : [
          input => this.isValidPLZ(input) || "Bitte geben Sie eine gültige Postleitzahl ein"
        ]
      }
    }
  },
  methods: {
    submitAnswer() {
      let newInputs = [
        {
          namebox: {
            enteredText: this.$data.nameInput,
            skipped: false,
          },
        },
        {
          birthdaybox: {
            enteredText: this.$data.birthdayInput,
            skipped: false,
          },
        },
        {
          addressbox: {
            enteredText: this.$data.addressInput,
            skipped: false,
          },
        },
        {
          plzbox: {
            enteredText: this.$data.plzInput,
            skipped: false,
          },
        },
        {
          citybox: {
            enteredText: this.$data.cityInput,
            skipped: false,
          },
        },
        {
          submitbutton: {
            clicked: true
          }
        }
      ]
      this.$emit("submitAnswer", newInputs)
    },
    updateContent(executableSystemAction) {
      console.log("Inside updateContent for Contact Detail Extended Card")

      let updatedContent = {
        responses: {
          namebox: executableSystemAction.guiTemplateContent.namebox,
          birthdaybox: executableSystemAction.guiTemplateContent.birthdaybox,
          addressbox: executableSystemAction.guiTemplateContent.addressbox,
          plzbox: executableSystemAction.guiTemplateContent.plzbox,
          citybox: executableSystemAction.guiTemplateContent.citybox,
          submitbutton: executableSystemAction.guiTemplateContent.submitbutton.text,
        },
      }

      // reset textbox inputs
      this.$data.nameInput = ""
      this.$data.birthdayInput = ""
      this.$data.addressInput = ""
      this.$data.plzInput = ""
      this.$data.cityInput = ""

      console.log(updatedContent)

      this.contentData = updatedContent
    },
    // sets the validationMessage and returns true/false whether the user input is valid or not
    isValidBirthday(birthdayToValidate) {
      if (birthdayToValidate === 0) {
        return false
      }
      let re = new RegExp("^(0[1-9]|[12][0-9]|3[01])[.](0[1-9]|1[012])[.](19|20)[0-9]{2}$")
      if (re.test(birthdayToValidate) === false) {
        return false
      }
      return true
    },
    isValidPLZ(plzToValidate){
      if (plzToValidate === 0) {
        return false
      }
      let re = new RegExp("^[0-9]{5}$")
      if (re.test(plzToValidate) === false) {
        return false
      }
      return true
    },
    // user may proceed when Name AND (Tel OR Email)
    userMayProceed() {
      return (
        this.isValidBirthday(this.birthdayInput) &&
        this.nameInput.length > 0 &&
        this.addressInput.length > 0 &&
        this.isValidPLZ(this.plzInput) &&
        this.cityInput.length > 0
      )
    },
  },
  mounted() {
    // fires an event to indicate Parent Component that DOM is updated and can be safely accessed
    this.$nextTick(() => {
      this.$emit("readyToUpdate")
    })
  },
}
</script>
